module.exports = __webpack_public_path__ + "img/blt-close03.79277570.svg";